import { supabaseClient } from "@/lib/supabase";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "@/utils/form";

const MAGIC_OTP_TYPES = ["magiclink", "email", "invite", "recovery"] as const;

const magicSearchSchema = z.object({
    token_hash: z.string().min(1),
    type: z.enum(MAGIC_OTP_TYPES).default("magiclink"),
});

export const Route = createFileRoute("/_auth/magic")({
    validateSearch: (search: Record<string, unknown>) => magicSearchSchema.parse(search),
    beforeLoad: async ({ search, context }) => {
        const { data, error } = await supabaseClient.auth.verifyOtp({
            token_hash: search.token_hash,
            type: search.type,
        });

        if (error || !data.user?.id) {
            console.error("[magic] verifyOtp failed", error?.message ?? "missing user");
            throw redirect({ to: "/login" });
        }

        context.auth.login(data.user.id);
        await context.queryClient.invalidateQueries({ queryKey: ["user"] });
        throw redirect({ to: "/authentication-complete" });
    },
    component: MagicLinkLanding,
});

function MagicLinkLanding() {
    return null;
}
